import React from 'react'  
import { Glyphicon } from '../../node_modules/react-bootstrap/lib/';


export const cronometro_label = (
  <p><Glyphicon glyph="time"/> Cron&oacute;metro</p>
);

export const registro_label = (
  <p><Glyphicon glyph="flash"/> Registrar Tiempos</p>
);

export const config_label = (
  <p><Glyphicon glyph="cog"/> Configuraci&oacute;n</p>
);

export const info_label = (
  <p><Glyphicon glyph="bullhorn"/> Premiaci&oacute;n</p>
);

export const stats_label = (
  <p><Glyphicon glyph="flag"/> Resultados</p>
);

export const import_label = (
  <p><Glyphicon glyph="floppy-open"/> Importar</p>
);

export const simulation_label = (
  <p><Glyphicon glyph="eye-open"/> Simular</p>
);

export const race_stats_label = (
  <p><Glyphicon glyph="stats"/> Estad&iacute;sticas</p>
);

export const race_visualization_label = (
  <p><Glyphicon glyph="eye-open"/> Visualizaci&oacute;n</p>
);

export const race_time_label = (
  <Glyphicon glyph="time"/>
);

export const race_place_label = (
  <Glyphicon glyph="map-marker"/>
);

export const race_fb_label = (
  <Glyphicon glyph="thumbs-up"/>
);

export const race_flag_label = (
  <Glyphicon glyph="flag"/>
);



// WEBPACK FOOTER //
// ./src/constants/icons.js